<template>
  <div v-if="comType == 'UI'">
    <div
      class="order-view"
      :style="{
        'border-radius': `${radius}px`,
        margin: `${marginTop}px ${marginRight}px ${marginBottom}px ${marginLeft}px`,
        padding: `${paddingTop}px ${paddingRight}px ${paddingBottom}px ${paddingLeft}px`,
        'background-color': backgroundColor,
      }"
      style="--buttonColor: #ee5654; --labelColor: #f16b6b"
    >
      <div class="left">
        <div>门店名称</div>
        <h1>订单状态</h1>
        <p>{{ decorationShopType == 4 ? "服务" : "商品" }}名称</p>
      </div>
      <div class="right">
        <div>
          <h1>01</h1>
          <p>取餐号</p>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="comType == 'config'">
    <el-form ref="form" label-width="100px" size="small">
      <div>
        <el-form-item label="背景颜色">
          <el-color-picker
            v-model="backgroundColorValue"
            :predefine="predefineColorsAlpha"
            size="small"
            show-alpha
          ></el-color-picker>
        </el-form-item>
        <div>
          <el-form-item label="圆角">
            <div class="slider-block">
              <el-slider v-model="radiusValue" show-input :min="0" :max="50"> </el-slider>
              <div class="set-radius">
                <el-popover placement="top" width="160" trigger="hover">
                  <radiusBox :radius="radiusValue"></radiusBox>
                  <el-button slot="reference">可见性</el-button>
                </el-popover>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="上间距">
            <div class="slider-block">
              <el-slider v-model="marginTopValue" show-input :min="-100" :max="100">
              </el-slider>
            </div>
          </el-form-item>
          <el-form-item label="下间距">
            <div class="slider-block">
              <el-slider v-model="marginBottomValue" show-input :min="0" :max="100">
              </el-slider>
            </div>
          </el-form-item>
          <el-form-item label="左间距">
            <div class="slider-block">
              <el-slider v-model="marginLeftValue" show-input :min="0" :max="100">
              </el-slider>
            </div>
          </el-form-item>
          <el-form-item label="右间距">
            <div class="slider-block">
              <el-slider v-model="marginRightValue" show-input :min="0" :max="100">
              </el-slider>
            </div>
          </el-form-item>
          <el-form-item label="上内间距">
            <div class="slider-block">
              <el-slider v-model="paddingTopValue" show-input :min="0" :max="100">
              </el-slider>
            </div>
          </el-form-item>
          <el-form-item label="下内间距">
            <div class="slider-block">
              <el-slider v-model="paddingBottomValue" show-input :min="0" :max="100">
              </el-slider>
            </div>
          </el-form-item>
          <el-form-item label="左内间距">
            <div class="slider-block">
              <el-slider v-model="paddingLeftValue" show-input :min="0" :max="100">
              </el-slider>
            </div>
          </el-form-item>
          <el-form-item label="右内间距">
            <div class="slider-block">
              <el-slider v-model="paddingRightValue" show-input :min="0" :max="100">
              </el-slider>
            </div>
          </el-form-item>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import radiusBox from "@/components/appltDecoration/radiusBox";
import { comMixins } from "@/mixins/comMixins";
export default {
  mixins: [comMixins],
  name: "comOrderStatus",
  components: {
    radiusBox,
  },
  props: {
    comType: {
      type: String,
      default: "UI",
    },
    marginTop: {
      type: Number,
      default: 0,
    },
    marginRight: {
      type: Number,
      default: 10,
    },
    marginBottom: {
      type: Number,
      default: 0,
    },
    marginLeft: {
      type: Number,
      default: 10,
    },
    paddingTop: {
      type: Number,
      default: 10,
    },
    paddingRight: {
      type: Number,
      default: 10,
    },
    paddingBottom: {
      type: Number,
      default: 10,
    },
    paddingLeft: {
      type: Number,
      default: 10,
    },
    backgroundColor: {
      type: String,
      default: "rgb(255, 255, 255)",
    },
    radius: {
      type: Number,
      default: 8,
    },
  },
  computed: {
    backgroundColorValue: {
      get() {
        return this.backgroundColor;
      },
      set(val) {
        this.$emit(`update:backgroundColor`, val);
      },
    },
    radiusValue: {
      get() {
        return this.radius;
      },
      set(val) {
        this.$emit(`update:radius`, val);
      },
    },
    marginTopValue: {
      get() {
        return this.marginTop;
      },
      set(val) {
        this.$emit(`update:marginTop`, val);
      },
    },
    marginRightValue: {
      get() {
        return this.marginRight;
      },
      set(val) {
        this.$emit(`update:marginRight`, val);
      },
    },
    marginBottomValue: {
      get() {
        return this.marginBottom;
      },
      set(val) {
        this.$emit(`update:marginBottom`, val);
      },
    },
    marginLeftValue: {
      get() {
        return this.marginLeft;
      },
      set(val) {
        this.$emit(`update:marginLeft`, val);
      },
    },
    paddingTopValue: {
      get() {
        return this.paddingTop;
      },
      set(val) {
        this.$emit(`update:paddingTop`, val);
      },
    },
    paddingRightValue: {
      get() {
        return this.paddingRight;
      },
      set(val) {
        this.$emit(`update:paddingRight`, val);
      },
    },
    paddingBottomValue: {
      get() {
        return this.paddingBottom;
      },
      set(val) {
        this.$emit(`update:paddingBottom`, val);
      },
    },
    paddingLeftValue: {
      get() {
        return this.paddingLeft;
      },
      set(val) {
        this.$emit(`update:paddingLeft`, val);
      },
    },
  },
};
</script>

<style scoped lang="less">
.order-view {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border: 1px solid var(--buttonColor);
}

.order-view .left {
  font-size: 12px;
  color: #909092;
}

.order-view .left h1 {
  font-weight: 700;
  font-size: 15px;
  color: var(--buttonColor);
  margin-top: 10px;
  margin-bottom: 2px;
}

.order-view .right {
  width: 90px;
  text-align: center;
  position: relative;
}

.order-view .right > div .name {
  margin-bottom: 5px;
}

.order-view .right > div h1 {
  font-weight: 700;
  font-size: 29px;
  color: var(--buttonColor);
}

.order-view .right > div span {
  font-weight: 700;
  font-size: 17px;
  color: var(--buttonColor);
}

.order-view .right > div p {
  font-size: 12px;
  color: #656565;
}

.order-view .right:after {
  content: "";
  position: absolute;
  width: 1px;
  height: 33px;
  background: #e8e8e8;
  left: 0;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
</style>
